import { TabView } from "../../components/embedded/tab";

export const Tab = TabView;
